import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import AppletsView from "./applets_view.js"
import RelatedServices from "../../related_services"
import EmptyStateCta from "shared/components/empty_state/index.tsx"
import { serviceShape, connectionShape } from "app/lib/shared_prop_types"

import Spinner from "shared/components/spinner"
import spinnerConfig from "../utils/spinner_config"

class SearchView extends React.Component {
  render() {
    return (
      <div className="search-body">
        {this.props.hideSuggestions ? (
          <>
            <main>
              {this.props.searchLoading ? (
                <Spinner config={spinnerConfig} />
              ) : (
                <>
                  <RelatedServices
                    services={this.props.services}
                    searchTerm={this.props.searchTerm}
                    path={service => `/${service.module_name}`}
                    location="search"
                  />
                  <AppletsView />
                </>
              )}
            </main>
          </>
        ) : (
          <EmptyStateCta
            heading="No results found"
            copy="Looks like we couldn't find any Applets or Service matches. Please try again."
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    applets: state.searchResults.applets,
    services: state.searchResults.services,
    searchTerm: state.searchResults.searchTerm,
    searchLoading: state.searchResults.searchLoading,
    hideSuggestions: state.searchResults.hideSuggestions,
  }
}

export default connect(mapStateToProps, null)(SearchView)

SearchView.propTypes = {
  applets: PropTypes.arrayOf(connectionShape),
  services: PropTypes.arrayOf(serviceShape),
  searchTerm: PropTypes.string,
  searchLoading: PropTypes.bool,
  hideSuggestions: PropTypes.bool,
}

SearchView.defaultProps = {
  applets: [],
  searchLoading: false,
  hideSuggestions: true,
}
